import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import { Autocomplete, TextField, Chip } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

function Index() {
  const [subjectName, setSubjectName] = useState("");
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  console.log("Subject ID from URL:", id);

  //get api se class ka data lana hai id ke sath input field mai show karne ke liye
  //aur fir update karne ke liye put api call karni hai

  useEffect(() => {
    // Fetch classes
    axios
      .get(`${baseURL}/classes`)
      .then((res) => {
        if (res.data.success) {
          const activeClasses = res.data.data.filter((cls) => !cls.isDeleted);
          setClasses(activeClasses);
        }
      })
      .catch((err) => {
        console.error("Error fetching classes:", err);
        toast.error("Failed to load classes");
      });

    // Fetch subject details
    axios
      .get(`${baseURL}/subjects/${id}`)
      .then((res) => {
        console.log("Subject details:", res.data);
        if (res.data.success) {
          setSubjectName(res.data.data.name);
          // Handle classes array - map to IDs if objects are returned
          const classIds =
            res.data.data.classes?.map((cls) => (typeof cls === "object" ? cls._id : cls)) || [];
          setSelectedClasses(classIds);
        }
      })
      .catch((err) => {
        console.error("Error fetching subject details:", err);
        toast.error("Failed to load subject details");
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subjectName.trim()) {
      toast.error("Subject name cannot be empty");
      return;
    }
    if (!selectedClasses || selectedClasses.length === 0) {
      toast.error("Please select at least one class");
      return;
    }

    setLoading(true);
    console.log("Updating Subject:", subjectName, "Classes:", selectedClasses);

    axios
      .put(`${baseURL}/subjects/${id}`, {
        name: subjectName,
        classes: selectedClasses,
      })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "Subject updated successfully");
        navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error updating subject:", error);
        toast.error(
          error.response?.data?.error || error.response?.data?.message || "Failed to update subject"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Edit Subject Name
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" flexDirection="column" gap={2}>
                {/* Multiple Class Selection with Autocomplete */}
                <ArgonBox>
                  <Autocomplete
                    multiple
                    id="class-autocomplete"
                    options={classes}
                    value={classes.filter((cls) => selectedClasses.includes(cls._id))}
                    onChange={(event, newValue) => {
                      setSelectedClasses(newValue.map((cls) => cls._id));
                    }}
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Classes *"
                        placeholder="Search and select classes"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            minHeight: "45px",
                          },
                        }}
                      />
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          {...getTagProps({ index })}
                          key={option._id}
                          label={option.name}
                          deleteIcon={<CancelIcon />}
                          sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            "& .MuiChip-deleteIcon": {
                              color: "white",
                              "&:hover": {
                                color: "#f0f0f0",
                              },
                            },
                          }}
                        />
                      ))
                    }
                  />
                </ArgonBox>

                {/* Subject Name Input */}
                <ArgonBox>
                  <ArgonInput
                    type="text"
                    placeholder="Enter Subject Name"
                    value={subjectName}
                    onChange={(e) => setSubjectName(e.target.value)}
                    fullWidth
                  />
                </ArgonBox>

                {/* Submit Button */}
                <ArgonBox>
                  <ArgonButton
                    color="primary"
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Subject"}
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;
